import menu from './menu';
// import permission from './permission';
// import user from './user';
console.log(menu)
export default {
    ...menu
    // permission,
    // user
};
